export function normalizePrivateBookingErrors(errors: Record<string, unknown>) {
  return Object.fromEntries(
    Object.entries(errors).map(([field, messages]) => [
      field.startsWith("booking.") ? field.slice("booking.".length) : field,
      messages,
    ]),
  );
}

export function bookingValidationMessages(errors: unknown): string[] {
  if (typeof errors === "string") {
    return errors ? [errors] : [];
  }
  if (!errors || typeof errors !== "object") {
    return [];
  }
  return Array.from(
    new Set(Object.values(errors).flatMap(bookingValidationMessages)),
  );
}
